import type { EmptyEventProps, EventName, EventPayloadMap } from '@repo/analytics';

/**
 * Server-safe helper to create typed analytics data attributes.
 *
 * Usage:
 *   <Link {...analyticsDataAttrs('explore_verified_listings', { page: 'Landing' })} />
 *
 * - Ensures `eventName` is a valid EventName (compile-time)
 * - Ensures `props` matches EventPayloadMap[eventName] (compile-time; no random keys)
 * - Makes `props` optional only when the event payload is "empty"
 */
export function analyticsDataAttrs<E extends EventName>(
  eventName: E,
  ...args: EventPayloadMap[E] extends EmptyEventProps
    ? [props?: EventPayloadMap[E]]
    : [props: EventPayloadMap[E]]
): { 'data-analytics-event': E; 'data-analytics-props': string } {
  const props = (args[0] ?? {}) as EventPayloadMap[E];
  return {
    'data-analytics-event': eventName,
    'data-analytics-props': JSON.stringify(props),
  };
}
